import { render, staticRenderFns } from "./AssessmentExampleCompleteModal.vue?vue&type=template&id=f40a3274&"
import script from "./AssessmentExampleCompleteModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentExampleCompleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports